// Firebase configuration using environment variables
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Helper function to check if running on production domain
export const isProductionDomain = (): boolean => {
  const domain = typeof window !== 'undefined' ? window.location.hostname : '';
  return domain === 'refer.solarinphoenix.com';
};

// Request configuration
export const MAX_RETRIES = 3;
export const RETRY_DELAY = 2000;
export const REQUEST_TIMEOUT = 15000;
